import { UPDATE_ALERT_STATUS_REQUEST } from '../constants/constants';

  export const updateAlertStatus = (payload) => {
    return {
      type: UPDATE_ALERT_STATUS_REQUEST,
      payload: payload,
    };
  };

